import { CastlingRights } from "./types";

// Convert piece map (e.g. { e4: 'wP', e8: 'bK' }) to standard FEN string
export function boardMapToFen(
  pieceMap: Record<string, string>,
  turn: "w" | "b" = "w",
  castling = "KQkq",
  epSquare = "-",
  halfMoves = 0,
  fullMoves = 1
): string {
  const ranks = [8, 7, 6, 5, 4, 3, 2, 1];
  const files = ["a", "b", "c", "d", "e", "f", "g", "h"];
  const fenRanks: string[] = [];

  for (const rank of ranks) {
    let emptyCount = 0;
    let rankStr = "";
    for (const file of files) {
      const square = `${file}${rank}`;
      const pieceCode = pieceMap[square];
      if (pieceCode) {
        if (emptyCount > 0) {
          rankStr += emptyCount.toString();
          emptyCount = 0;
        }
        const color = pieceCode[0];
        const type = pieceCode[1].toLowerCase();
        rankStr += color === "w" ? type.toUpperCase() : type.toLowerCase();
      } else {
        emptyCount++;
      }
    }
    if (emptyCount > 0) {
      rankStr += emptyCount.toString();
    }
    fenRanks.push(rankStr);
  }

  const piecePlacement = fenRanks.join("/");
  return `${piecePlacement} ${turn} ${castling || "-"} ${epSquare} ${halfMoves} ${fullMoves}`;
}

// Convert FEN string to piece map (e.g. { e4: 'wP', e8: 'bK' })
export function fenToPieceMap(fen: string): Record<string, string> {
  const piecePlacement = fen.split(" ")[0];
  const ranks = piecePlacement.split("/");
  const pieceMap: Record<string, string> = {};
  const files = ["a", "b", "c", "d", "e", "f", "g", "h"];

  ranks.forEach((rankStr, rankIndex) => {
    const rank = 8 - rankIndex;
    let fileIndex = 0;
    for (const char of rankStr) {
      if (char >= "1" && char <= "8") {
        fileIndex += parseInt(char, 10);
      } else {
        const file = files[fileIndex];
        const square = `${file}${rank}`;
        const color = char === char.toUpperCase() ? "w" : "b";
        const type = char.toUpperCase();
        pieceMap[square] = `${color}${type}`;
        fileIndex++;
      }
    }
  });

  return pieceMap;
}

// Convert castling object to string representation (e.g. 'KQkq' or '-')
export function getCastlingString(c: CastlingRights): string {
  let str = "";
  if (c.K) str += "K";
  if (c.Q) str += "Q";
  if (c.k) str += "k";
  if (c.q) str += "q";
  return str || "-";
}
